"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "baia-e-latina": {
    "34813aca": [{
      "hkey": "c6f82271",
      "slug": "baia-e-latina",
      "name": "Baia e Latina",
      "primary": true,
      "skipSearch": false
    }],
    "contra": [{
      "hkey": "c6f82271",
      "slug": "baia-e-latina",
      "name": "Baia e Latina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;